import { RumInit } from "@maersk-global/telemetry-web-sdk";
import { trace } from "./trace";
import getConfig from "next/config";

export const initFaro = () => {
  // RUM is opt-in per portal: CI only pulls RUM_API_KEY from vault when the
  // repo variable ENABLE_RUM is 'true', otherwise the key compiles to undefined.
  // Booting Faro without one still ships beacons to the Argus collector, and
  // every one of them comes back 401 — so stay uninitialised instead.
  const apiKey = process.env.RUM_API_KEY;

  // The app name and environment must match the registration that issued the
  // key (see env-vars.js). Argus rejects a mismatched name with HTTP 429 — not
  // 401 — so a wrong name looks like rate limiting and is pure noise. If the
  // configmap has not been filled in, send nothing rather than send it wrong.
  const { publicRuntimeConfig } = getConfig();
  const appName = publicRuntimeConfig?.RUM_APP_NAME;
  const appEnv = publicRuntimeConfig?.RUM_ENV;

  if (!apiKey || !appName || !appEnv) return;

  const faro = RumInit({
    app: {
      name: appName,
      // Inlined from package.json at build time by next.config.js.
      version: process.env.RUM_APP_VERSION ?? "0.0.0",
      environment: appEnv,
    },
    apiKey,
    traceLog: true,
    useSendBeacon: true,
    debug: false,
    instrumentations: {
      interactions: { eventNames: ["click"] },
    },
    performanceInstrument: {
      ignoreEvents: ["msal.*", "vue.*"],
    },
    ignoreUrls: [],
    ignoreErrors: ["Script error."],
  });

  trace.init(faro);
};
